import { Color } from '@tmh-website/shared/colors';
import styled, { css } from 'styled-components';

const transitionCss = css`
  transition: transform 0.25s ${props => props.theme.transitionTimingFunctionBouncy};
  transform-origin: 80% 20%;
`;

export const Count = styled.text<{ $isFadeOut: boolean }>`
  ${transitionCss}
  font-family: ${props => props.theme.fontFamily.body};
  font-size: 220px;
  font-weight: ${props => props.theme.fontWeight.medium};
  line-height: 1;
  fill: ${props => props.theme.color[Color.Neutral_0_White]};
  ${props => props.$isFadeOut && 'transition-timing-function: ease-in;'}
`;

export const RectWithTransition = styled.rect<{ $isFadeOut: boolean }>`
  ${transitionCss}
  ${props => props.$isFadeOut && 'transition-timing-function: ease-in;'}
`;
